import React from "react";

interface ToggleSwitchProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  onChange,
  label,
}) => {
  const handleToggle = () => {
    onChange(!checked);
  };

  return (
    <label htmlFor={id} className="flex items-center cursor-pointer">
        {label && (
          <span className="mr-3 text-gray-700 dark:text-gray-300 font-medium">
            {label}
          </span>
        )}
      <div className="relative">
        <input
          id={id}
          type="checkbox"
          className="sr-only" // Hide the default checkbox
          checked={checked}
          onChange={handleToggle}
        />
        <div
          className={`block w-10 h-6 rounded-full transition-colors ${
            checked ? "bg-[#776ce6]" : "bg-gray-300 dark:bg-gray-600"
          }`}
        >
          <div
            className={` absolute left-1 top-1/2 -translate-y-1/2 bg-white w-4 h-4 rounded-full transition-transform ${
              checked ? "transform translate-x-4" : ""
            }`}
          ></div>{" "}
        </div>
      </div>
    </label>
  );
};

export default ToggleSwitch;
